export interface ProgressBar {
	css?: string;
	progress: number;
}

export type ProgressBarSize = "progress-lg" | "" | "progress-sm" | "progress-xs" | "progress-xxs" | "progress-micro";

export interface ProgressBarConfig {
	size?: ProgressBarSize;
	barScale?: number;
}

export function renderProgress(bar: ProgressBar | ProgressBar[], config: ProgressBarConfig = {}) {
	if (!Array.isArray(bar)) {
		bar = [bar];
	}

	if (config.barScale == null) {
		config.barScale = 1;
	}

	const barScalePercentage = config.barScale * 100;

	return `<div class="progress ${config.size || ""}" style="width: ${barScalePercentage}%" >
				${bar.map(b => renderProgressBar(b, config)).join("")}
			</div>`;
}

function renderProgressBar(bar: ProgressBar, config: ProgressBarConfig) {
	const progressPercentage = config.barScale !== 0
		? bar.progress * (1 / config.barScale) * 100
		: 0;

	return `<div class="progress-bar ${bar.css || ""}" style="width:${progressPercentage}%">
				</div>`;
}
